const FlowerBox = ({ children }) => {
  return (
      <div className="w-full mx-auto max-w-screen-xl">
        <div className="relative">
          {children}
        </div>
    </div>
  );
};

export default FlowerBox;